import {
    SimplePageContentWrapper,
    SimplePageLayout
} from '@flexinet/ui-components';
import {useState} from 'react';

import {IndexPageHeader} from '../components/IndexPageHeader';
import {IndexPageNavigation} from "../navigation/IndexPageNavigation";
import {RecordsTable} from "../tables/RecordsTable.tsx";
import {AliasStatus} from '../types';
import {AliasFilters} from '../buttons/FilterRecordsButton';

export const IndexPage = () => {
    const [filters, setFilters] = useState<AliasFilters>({aliasStatus: AliasStatus.ENABLED, aliasType: null});

    return (
        <SimplePageLayout
            pageHeader={<IndexPageHeader onFilterChange={setFilters}/>}
            pageNavigation={<IndexPageNavigation/>}
        >
            <SimplePageContentWrapper>
                <RecordsTable filters={filters}/>
            </SimplePageContentWrapper>
        </SimplePageLayout>
    );
};
